import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ctaLabel } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const closing = document.getElementById('comprar');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const closingTop = closing ? closing.getBoundingClientRect().top : Number.POSITIVE_INFINITY;

      // Show after scrolling past the hero, hide once the final price section is in view.
      const pastHero = heroBottom < 0;
      const atPrice = closingTop < window.innerHeight * 0.9;
      setVisible(pastHero && !atPrice);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-86" data-mp="33ifj9lbnvide">
      {visible && <motion.a href="#comprar" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-pink text-[15px] font-extrabold text-surface shadow-cta-bar md:hidden" data-id="element-87" data-mp="2z1fs5oo4ft4b">
          {ctaLabel}
        </motion.a>}
    </AnimatePresence>;
}